<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="sai"> </p>
<p class="EPVT">THE SAIL</p>
<p class="EPV">A white sail gleams alone out yonder</p>
<p class="EPV">Amid the ocean’s pale-blue haze … </p>
<p class="EPV">What quest has driven him to wander?</p>
<p class="EPV">Why has he left his native bays?</p>
<p class="EPV-SB">The waves crest as the fresh wind rises,</p>
<p class="EPV">The mainmast bending in the breeze … </p>
<p class="EPV">It is not happiness he prizes,</p>
<p class="EPV">Nor is it happiness he flees!</p>
<p class="EPV-SB">Beneath, the azure current flowing;</p>
<p class="EPV">Above, the golden sunlight glows … </p>
<p class="EPV">Perverse, he seeks the storm winds blowing,</p>
<p class="EPV">As if in storms to find repose!</p>
<p class="EPVS">—Mikhail Lermontov; translated by Alan Myers</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sail.vue?2f40138c